let _isAdmin = false;
export default class User {
  constructor(user = {}, metadata = {}) {
    this.givenName = user.name.givenName;
    this.surName = user.name.familyName;
    this.displayName = user.displayName;
    this.email = metadata.email;
    this.userKey = user.id;
    this.accountKey = metadata.accountKey;
    this.userTimeZone = user.timezone;
    this.userLocale = user.locale;
    this.entitlements = user.entitlements;
    this.seats = metadata.seats;
    this.created = user.meta.created;
  }

  get userLocaleShort() {
    return this.userLocale ? this.userLocale.substr(0, 2).toLowerCase() : 'en';
  }

  static set isAdmin(isAdmin) {
    _isAdmin = isAdmin;
  }

  static get isAdmin() {
    return _isAdmin;
  }
}



// WEBPACK FOOTER //
// ./src/Model/User.js